module.exports = __webpack_public_path__ + "static/media/ai_sg_logo.83c3c0dc.png";